document.addEventListener("DOMContentLoaded", function () {
  if (window.location.href.includes("#filtered-blog")) {
    const mainBlog = document.getElementById("main-blog");
    if (mainBlog) {
      // offset due to sticky header
      const offset = 160; // change this to match your theme
      const top =
        mainBlog.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  }
});
